/**
 * Product Image Zoom — Lightbox with pinch/scroll zoom
 * Click on product image → fullscreen dialog with zoom capability
 */
(function() {
  var dialog = null;
  var img = null;
  var closeBtn = null;
  var scale = 1;
  var minScale = 1;
  var maxScale = 4;
  var panX = 0, panY = 0;
  var startDist = 0;
  var startScale = 1;
  var isPanning = false;
  var startPanX = 0, startPanY = 0;
  var startMouseX = 0, startMouseY = 0;

  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'product-zoom-dialog';
    dialog.innerHTML = '<button class="product-zoom-close" aria-label="Close">' +
      '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.2">' +
      '<path d="M2 2l10 10M12 2L2 12"/></svg></button>' +
      '<div class="product-zoom-container"><img class="product-zoom-img" draggable="false"></div>';
    document.body.appendChild(dialog);

    img = dialog.querySelector('.product-zoom-img');
    closeBtn = dialog.querySelector('.product-zoom-close');

    closeBtn.addEventListener('click', close);
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) close();
    });
    dialog.addEventListener('cancel', function(e) {
      e.preventDefault();
      close();
    });

    // Desktop: scroll to zoom
    dialog.addEventListener('wheel', function(e) {
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.15 : 0.15;
      setScale(scale + delta, e.clientX, e.clientY);
    }, { passive: false });

    // Desktop: click to toggle zoom
    img.addEventListener('click', function(e) {
      if (scale > 1.1) {
        resetZoom();
      } else {
        setScale(2.5, e.clientX, e.clientY);
      }
    });

    // Desktop: drag to pan
    img.addEventListener('mousedown', function(e) {
      if (scale <= 1.05) return;
      e.preventDefault();
      isPanning = true;
      startMouseX = e.clientX;
      startMouseY = e.clientY;
      startPanX = panX;
      startPanY = panY;
      img.style.cursor = 'grabbing';
    });
    document.addEventListener('mousemove', function(e) {
      if (!isPanning) return;
      panX = startPanX + (e.clientX - startMouseX);
      panY = startPanY + (e.clientY - startMouseY);
      applyTransform();
    });
    document.addEventListener('mouseup', function() {
      isPanning = false;
      if (img) img.style.cursor = scale > 1.05 ? 'grab' : 'zoom-in';
    });

    // Mobile: pinch to zoom + drag to pan
    var touches = {};
    dialog.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        startDist = getTouchDist(e.touches);
        startScale = scale;
      } else if (e.touches.length === 1 && scale > 1.05) {
        isPanning = true;
        startMouseX = e.touches[0].clientX;
        startMouseY = e.touches[0].clientY;
        startPanX = panX;
        startPanY = panY;
      }
    }, { passive: false });

    dialog.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var dist = getTouchDist(e.touches);
        var newScale = startScale * (dist / startDist);
        var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        setScale(newScale, midX, midY);
      } else if (e.touches.length === 1 && isPanning) {
        e.preventDefault();
        panX = startPanX + (e.touches[0].clientX - startMouseX);
        panY = startPanY + (e.touches[0].clientY - startMouseY);
        applyTransform();
      }
    }, { passive: false });

    dialog.addEventListener('touchend', function(e) {
      isPanning = false;
    });

    // Double-tap to zoom
    var lastTap = 0;
    img.addEventListener('touchend', function(e) {
      if (e.changedTouches.length !== 1) return;
      var now = Date.now();
      if (now - lastTap < 300) {
        e.preventDefault();
        if (scale > 1.1) {
          resetZoom();
        } else {
          setScale(2.5, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        }
      }
      lastTap = now;
    });
  }

  function getTouchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function setScale(newScale, originX, originY) {
    newScale = Math.max(minScale, Math.min(maxScale, newScale));
    if (newScale !== scale) {
      // Adjust pan to zoom toward cursor/touch point
      var rect = img.getBoundingClientRect();
      var imgCenterX = rect.left + rect.width / 2;
      var imgCenterY = rect.top + rect.height / 2;
      var dx = originX - imgCenterX;
      var dy = originY - imgCenterY;
      var factor = newScale / scale;
      panX = panX - dx * (factor - 1);
      panY = panY - dy * (factor - 1);
      scale = newScale;
      applyTransform();
      img.style.cursor = scale > 1.05 ? 'grab' : 'zoom-in';
    }
  }

  function resetZoom() {
    scale = 1;
    panX = 0;
    panY = 0;
    applyTransform();
    img.style.cursor = 'zoom-in';
  }

  function applyTransform() {
    img.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
  }

  function open(src) {
    if (!dialog) createDialog();
    resetZoom();
    img.src = src;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (dialog && dialog.open) {
      dialog.close();
      document.body.style.overflow = '';
    }
  }

  // Attach click handlers to product images
  document.addEventListener('DOMContentLoaded', function() {
    var container = document.querySelector('.product__images');
    if (!container) return;

    container.addEventListener('click', function(e) {
      var slide = e.target.closest('.swiper-slide');
      if (!slide) return;
      var imgEl = slide.querySelector('img');
      if (!imgEl) return;
      // Get highest resolution src
      var src = imgEl.src.replace(/width=\d+/, 'width=3000');
      open(src);
    });
  });
})();
